/** Supported application themes (stored in localStorage and user profile). */
export const APP_THEMES = [
  "light",
  "dark",
  "solarized-light",
  "solarized-dark",
  "pastel-blue",
  "mac-silver",
] as const;

export type AppTheme = (typeof APP_THEMES)[number];

export const DEFAULT_THEME: AppTheme = "light";

export type ThemeMeta = {
  id: AppTheme;
  labelKey:
    | "common.themeLight"
    | "common.themeDark"
    | "common.themeSolarizedLight"
    | "common.themeSolarizedDark"
    | "common.themePastelBlue"
    | "common.themeMacSilver";
  isDark: boolean;
};

export const THEME_CATALOG: ThemeMeta[] = [
  { id: "light", labelKey: "common.themeLight", isDark: false },
  { id: "dark", labelKey: "common.themeDark", isDark: true },
  { id: "solarized-light", labelKey: "common.themeSolarizedLight", isDark: false },
  { id: "solarized-dark", labelKey: "common.themeSolarizedDark", isDark: true },
  { id: "pastel-blue", labelKey: "common.themePastelBlue", isDark: false },
  { id: "mac-silver", labelKey: "common.themeMacSilver", isDark: false },
];

export function isAppTheme(value: string | null | undefined): value is AppTheme {
  return APP_THEMES.includes(value as AppTheme);
}

export function isDarkTheme(theme: AppTheme): boolean {
  return THEME_CATALOG.find((entry) => entry.id === theme)?.isDark ?? false;
}
